import * as React from 'react';

import { cn, withColor } from '../../lib/stylingUtils';
import { ThemeColor } from '../../types/theme';
import { Col, Row } from '../ui';

export type ListStatsCardProps = {
  stats: {
    key: string;
    label: React.ReactNode;
    value: React.ReactNode;
    icon?: React.ReactNode;
    color?: ThemeColor;
  }[];
};

export const ListStatsCard = ({ stats }: ListStatsCardProps) => (
  <Row className="@ListStatsCard rounded-md border border-neutral/15 bg-space px-4 py-2.5">
    {stats.map((stat, index) => (
      <Col
        key={stat.key}
        className={cn(
          'w-full max-w-55',
          index > 0 && 'border-l border-neutral/15 pl-4',
        )}
      >
        <div className={'text-sm text-neutral/60 capitalize'}>{stat.label}</div>
        <Row className={'text-xl font-semibold'} gap2>
          {stat.icon && (
            <span
              className={cn('contents text-custom-color [&_svg]:size-5')}
              style={withColor(stat.color ?? 'primary')}
            >
              {stat.icon}
            </span>
          )}
          {stat.value}
        </Row>
      </Col>
    ))}
  </Row>
);
